export enum LocalStorageKeys {
  PhoneNumber = 'phone_number',
  AccessToken = 'accessToken',
  RefreshToken = 'refreshToken',
  TimeZone = 'timeZone',
  Uuid = 'uuid',
}
